import { Modal, Tag, Row, Col } from "antd";
import { Icon } from "@iconify/react/dist/iconify.js";
import { formatDateToDMY } from "../../utils/tools";

const Item = ({ label, value }) => (
    <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>{label}</div>
        <div style={{ fontSize: 15, fontWeight: 500, wordBreak: "break-word" }}>{value ?? "-"}</div>
    </div>
);

const isExpired = (expiresAt) => !expiresAt || new Date(expiresAt) < new Date();

const SubscriberViewModal = ({ open, onClose, data }) => {
    if (!data) return null;

    const expired = isExpired(data.expires_at);
    const statusTag = data.is_active && !expired
        ? <Tag color="success">Active</Tag>
        : expired
            ? <Tag color="error">Expired</Tag>
            : <Tag color="warning">Inactive</Tag>;

    const planColor = data.type === "yearly" ? "gold" : data.type === "monthly" ? "blue" : "default";

    const platformIcon = data.platform === "android"
        ? <Icon icon="logos:android-icon" width="18" style={{ marginRight: 4 }} />
        : data.platform === "ios"
            ? <Icon icon="logos:apple" width="16" style={{ marginRight: 4 }} />
            : null;

    return (
        <Modal
            title="Subscriber Details"
            open={open}
            onCancel={onClose}
            footer={null}
            width={650}
            centered
        >
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
                <img
                    src={data.user?.avatar || "/assets/images/logo-profile.png"}
                    alt={data.user?.name}
                    width={52}
                    height={52}
                    className="rounded-circle"
                    style={{ objectFit: "cover", border: "2px solid #e8e8e8" }}
                    onError={(e) => { e.target.src = "/assets/images/logo-profile.png"; }}
                />
                <div>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{data.user?.name || "—"}</div>
                    <div style={{ color: "#888", fontSize: 13 }}>{data.user?.email || "—"}</div>
                </div>
            </div>

            <Row gutter={[16, 4]}>
                <Col xs={24} sm={12}>
                    <Item label="Subscription ID" value={data.id} />
                </Col>
                <Col xs={24} sm={12}>
                    <Item
                        label="Plan"
                        value={
                            <Tag color={planColor} className="text-capitalize fw-semibold">
                                {data.type || "—"}
                            </Tag>
                        }
                    />
                </Col>
                <Col xs={24} sm={12}>
                    <Item
                        label="Platform"
                        value={
                            <span className="d-flex align-items-center">
                                {platformIcon}
                                <span className="text-capitalize">{data.platform || "—"}</span>
                            </span>
                        }
                    />
                </Col>
                <Col xs={24} sm={12}>
                    <Item label="Status" value={statusTag} />
                </Col>
                <Col xs={24} sm={12}>
                    <Item label="Subscribed On" value={data.created_at ? formatDateToDMY(data.created_at) : "—"} />
                </Col>
                <Col xs={24} sm={12}>
                    <Item
                        label="Expires On"
                        value={
                            <span className={expired ? "text-danger" : "text-success"}>
                                {data.expires_at ? formatDateToDMY(data.expires_at) : "—"}
                            </span>
                        }
                    />
                </Col>
                <Col xs={24}>
                    <Item label="Product ID" value={data.product_id} />
                </Col>
                <Col xs={24}>
                    <Item label="Purchase Token" value={data.purchase_token} />
                </Col>
            </Row>
        </Modal>
    );
};

export default SubscriberViewModal;
